import { render, staticRenderFns } from "./InboundSmsNotification.vue?vue&type=template&id=6cc1992d&scoped=true&"
import script from "./InboundSmsNotification.vue?vue&type=script&lang=js&"
export * from "./InboundSmsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc1992d",
  null
  
)

export default component.exports